class QuickFilter extends window.BAO.CustomElement() {
  static get requiredElements () {
    return ['quickfilter']
  }

  static get requiredExternalElements () {
    return ['content', 'item', 'search']
  }

  connectedCallback () {
    this.search = this.externalEls.search.element

    this.filterListItems = this.closest(
      this.externalEls?.content?.selector,
    ).querySelectorAll(this.externalEls?.item?.selector)

    this.container = this.els.quickfilter.element
    this.btns = []

    this.createQuickFilter()
  }

  renderQuickFilterButton (brand) {
    const btn = document.createElement('span')
    if (brand === null) {
      btn.innerText = this.container.dataset.showAllText || 'Show All'
      btn.setAttribute('data-active', true)
    } else {
      btn.innerText = brand
      btn.setAttribute('data-brand', brand)
    }

    btn.setAttribute(
      'class',
      'sec-QuickFilter_Button btn-Button btn-Button-secondary',
    )

    btn.addEventListener('click', evt => {
      evt.preventDefault()

      const isActive = btn.getAttribute('data-active')

      if (isActive) {
        return
      }

      this.applyQuickFilter(brand)
      btn.setAttribute('data-active', true)
    })

    this.btns.push(btn)
    this.container.appendChild(btn)
  }

  removeQuickFilter () {
    this.btns.forEach(btn => {
      btn.removeAttribute('data-active')
    })

    this.filterListItems.forEach(item => {
      item.classList.remove('sec-QuickFilter_Hidden')
    })
  }

  applyQuickFilter (brand) {
    this.removeQuickFilter()

    if (brand === null) {
      return
    }

    this.filterListItems.forEach(item => {
      if (item.dataset.brand !== brand) {
        item.classList.add('sec-QuickFilter_Hidden')
      }
    })
  }

  hide () {
    this.container.setAttribute('aria-hidden', 'true')
  }

  createQuickFilter () {
    const brands = [...this.filterListItems].reduce((acc, item) => {
      const [brand] = item.dataset.filterValue.split(' ')

      if (brand !== '') {
        item.setAttribute('data-brand', brand)
        acc.add(brand)
      }

      return acc
    }, new Set())

    if (brands.size < 2) {
      this.hide()
      return
    }

    brands.forEach(brand => {
      this.renderQuickFilterButton(brand)
    })

    this.renderQuickFilterButton(null)
  }
}

if (!customElements.get('quick-filter')) {
  customElements.define('quick-filter', QuickFilter)
}
